import React from 'react';

import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import { useSelfInspectionDataContext } from '../../../../context/SelfInspection/selfInspection.provider';

const Documentation = () => {
  const { nextStep } = useSelfInspectionDataContext();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6">
            Siga los siguientes pasos para realizar la inspección exitosamente
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <List aria-label="detalles">
          <ListItem>
            <ListItemIcon>
              <OkIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2">
                  Tome las fotografías de los diferentes ángulos de su vehículo
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <OkIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2">
                  Suba una foto de la cédula Verde o Azul donde se vean los
                  datos del vehículo
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Box my={3} style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            onClick={() => nextStep()}
            variant="contained"
            color="primary"
          >
            Comenzar
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Documentation;
